import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

const selectAuthFeature = createFeatureSelector<AuthState>('auth');

export const selectEmailCheckResult = createSelector(selectAuthFeature, (state: AuthState) => ({
  existing_user: state.existing_user,
  company: state.company,
  email: state.email,
}));

export const selectCheckedEmail = createSelector(selectAuthFeature, (state: AuthState) => ({
  email: state.email || null,
}));

export const selectToken = createSelector(selectAuthFeature, (state: AuthState) => ({
  token: state.token,
}));

export const selectCheckedEmailResult = createSelector(selectAuthFeature, (state: AuthState) => ({
  existing_user: state.existing_user,
  company: state.company,
}));

export const selectForgotPasswordSuccess = createSelector(
  selectAuthFeature,
  (state: AuthState) => state.forgotPasswordSuccess
);

export const selectAuthError = createSelector(selectAuthFeature, (state: AuthState) => state.error);

export const selectPendingPartnerSubscriptionOfferAfterSignUp = createSelector(
  selectAuthFeature,
  (state: AuthState) => state.pendingPartnerSubscriptionOfferAfterSignUp
);
